import CarrierRegistrationTypes from './CarrierRegistrationTypes';

export const registerEmailInProgress = (payload) => {
  return {
    type: CarrierRegistrationTypes.REGISTER_EMAIL_PROGRESS,
    payload,
  };
};

export const registerEmailInSuccess = (payload) => {
  return {
    type: CarrierRegistrationTypes.REGISTER_EMAIL_SUCCESS,
    payload,
  };
};

export const registerEmailInError = (payload) => {
  return {
    type: CarrierRegistrationTypes.REGISTER_EMAIL_ERROR,
    payload,
  };
};

export const getRegisterEmailInProgress = (payload) => {
  return {
    type: CarrierRegistrationTypes.GET_REGISTER_EMAIL_PROGRESS,
    payload,
  };
};

export const getRegisterEmailInSuccess = (payload) => {
  return {
    type: CarrierRegistrationTypes.GET_REGISTER_EMAIL_SUCCESS,
    payload,
  };
};

export const getRegisterEmailInError = (payload) => {
  return {
    type: CarrierRegistrationTypes.GET_REGISTER_EMAIL_ERROR,
    payload,
  };
};
export const deactivateRegisterEmailInProgress = (payload) => {
  return {
    type: CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_PROGRESS,
    payload,
  };
};

export const deactivateRegisterEmailInSuccess = (payload) => {
  return {
    type: CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_SUCCESS,
    payload,
  };
};

export const deactivateRegisterEmailInError = (payload) => {
  return {
    type: CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_ERROR,
    payload,
  };
};
